/**
 * App radio component
 */

// React
import React, { FC, ReactNode } from 'react';

// Material
import { styled } from '@mui/material/styles';
import Radio, { RadioProps } from '@mui/material/Radio';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Typography } from '@mui/material';

// Styled
const BpIcon = styled('span')({
  borderRadius: '50%',
  width: 20,
  height: 20,
  boxShadow: 'inset 0 0 0 1px #ccc, inset 0 -1px 0 #ccc',
  'input:hover ~ &': {
    backgroundColor: '#ebf1f580',
  },
});

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#6EC8E2',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  boxShadow: 'unset',
  '&::before': {
    display: 'block',
    width: 20,
    height: 20,
    backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
    content: '""',
  },
  'input:hover ~ &': {
    backgroundColor: '#6EC8E2',
  },
});

// Interface
interface AppRadioProps extends RadioProps {
  name?: string;
  icon?: React.ReactNode;
  checkedIcon?: React.ReactNode;
  label?: string | React.ReactNode;
}

// Component
const AppRadio: FC<AppRadioProps> = ({ label, ...rest }) => {
  const renderLabel = (): ReactNode => {
    if (typeof label === 'string') {
      return (
        <Typography fontWeight={500} color="#666666">
          {label}
        </Typography>
      );
    }
    return label;
  };

  return (
    <FormControlLabel
      control={<Radio disableRipple checkedIcon={<BpCheckedIcon />} icon={<BpIcon />} {...rest} />}
      label={renderLabel()}
    />
  );
};

export default AppRadio;
